import { ArrowUp } from 'lucide-react';
import { RefObject, useEffect, useState } from 'react';

type Props = {
  scrollContainerRef: RefObject<HTMLElement | null>;
  thresholdPx?: number;
};

export default function BackToTop({ scrollContainerRef, thresholdPx = 300 }: Props) {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const el = scrollContainerRef.current;
    if (!el) return;

    const onScroll = () => setIsVisible(el.scrollTop > thresholdPx);

    onScroll();
    el.addEventListener('scroll', onScroll, { passive: true });
    return () => el.removeEventListener('scroll', onScroll);
  }, [scrollContainerRef, thresholdPx]);

  const scrollToTop = () => {
    scrollContainerRef.current?.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <button
      type="button"
      className={`fixed right-6 bottom-4 z-50 flex h-10 w-10 items-center justify-center rounded-full bg-secondaryPurple text-primary shadow transition-opacity duration-300 ${
        isVisible ? 'opacity-100' : 'pointer-events-none opacity-0'
      }`}
      onClick={scrollToTop}
      aria-label="Retour en haut"
    >
      <ArrowUp size={20} />
    </button>
  );
}
